import { RefObject, useState } from 'react';

import { useCatalogProductIdParams } from '@domains/pdp-common';

import { BoxStatus } from '../components/PolicyList';
import { useContactInfo } from '../queries/useContactInfoQuery';

export type BoxRef = {
  [key: string]: RefObject<HTMLElement>;
};

export const usePolicyListService = () => {
  const param = useCatalogProductIdParams();
  const { policy_list: policyList = [] } = useContactInfo(param);

  const [policyListOpenStatus, setPolicyListOpenStatus] = useState<BoxStatus>(
    policyList.reduce((acc, cur) => ({ ...acc, [cur.main_title]: false }), {}),
  );

  const handleBoxClick = (key: string) => {
    setPolicyListOpenStatus({ ...policyListOpenStatus, [key]: !policyListOpenStatus[key] });
  };

  return {
    policyList,
    policyListOpenStatus,
    handleBoxClick,
  };
};
